import $ from "jquery";

export function wpformsCustom() {
  let form = document.getElementById("wpforms-873");
  let form2 = document.getElementById("wpforms-1706");
  if (form2) {
    form = form2;
  }

  if (!form) return;

  // KORRIGIERTER SELEKTOR: Sucht nach dem konstanten Teil des Namens ohne äußere Klammern
  const RADIO_INPUT_SELECTOR = 'input[name*="fields][88"][type="radio"]';

  // Die weiteren Selektoren bleiben gleich:
  const REPEATER_ADD_BUTTON_SELECTOR = ".wpforms-field-repeater-button-add";
  const LAYOUT_ROW_CLASS = ".wpforms-layout-row";
  const TEXTAREA_FIELD_SELECTOR = '.wpforms-field[data-field-id^="78"]';

  // -------------------------------------------------------------------
  // Die Funktion applyConditionalLogic bleibt unverändert und korrekt
  function applyConditionalLogic(radio) {
    const radioRow = radio.closest(LAYOUT_ROW_CLASS);
    if (!radioRow) return;

    const textareaRow = radioRow.nextElementSibling;
    if (
      !textareaRow ||
      !textareaRow.classList.contains(LAYOUT_ROW_CLASS.substring(1))
    ) {
      return;
    }

    const textareaFieldContainer = textareaRow.querySelector(
      TEXTAREA_FIELD_SELECTOR,
    );
    const textareaField = textareaFieldContainer
      ? textareaFieldContainer.querySelector("textarea")
      : null;

    if (!textareaFieldContainer || !textareaField) return;

    if (radio.value === "Ja" && radio.checked) {
      textareaFieldContainer.style.setProperty("display", "block", "important");
      textareaField.setAttribute("required", "required");
    } else {
      textareaFieldContainer.style.setProperty("display", "none", "important");
      textareaField.removeAttribute("required");
      textareaField.value = "";
    }
  }
  // -------------------------------------------------------------------

  // Setzt den initialen Zustand für alle Radio-Buttons
  function initializeAllRadioStates() {
    form.querySelectorAll(RADIO_INPUT_SELECTOR).forEach((radio) => {
      if (radio.checked) {
        applyConditionalLogic(radio);
      }
    });
  }

  // --- 1. Event Delegation für Klicks ---
  form.addEventListener("change", function (e) {
    const target = e.target;

    // DIESER TEIL WIRD NUN MIT DEM NEUEN SELEKTOR GETESTET
    if (target.matches(RADIO_INPUT_SELECTOR)) {
      //console.log("SUCCESS: Radio Match gefunden."); // Überprüfe diesen Log!
      applyConditionalLogic(target);
    } else {
      /*console.log(
        "FEHLER: Target ist ein Element, aber Match schlug fehl.",
        target,
      );*/
    }
  });

  // --- 2. Listener für den "Add Item" Button ---
  const repeaterAddButton = form.querySelector(REPEATER_ADD_BUTTON_SELECTOR);
  if (repeaterAddButton) {
    repeaterAddButton.addEventListener("click", function () {
      setTimeout(() => {
        // Initialisiert auch die neuen Repeater-Instanzen
        initializeAllRadioStates();
      }, 100);
    });
  }

  // --- 3. Initialer Aufruf ---
  initializeAllRadioStates();
}
